import { useQueryClient } from '@tanstack/react-query';

export function withQueryClient(C: any) {
  const Wrapper = (props: any) => {
    const queryClient = useQueryClient();
    return <C queryClient={queryClient} {...props} />;
  };

  Wrapper.displayName = 'withQueryClient';

  return Wrapper;
}
